module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BlackItalic-WebXL-9274ea26f6482098f36fda310835871a.woff2";